import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIError } from '..';
import { handleListFetch } from '../apiHelpers';
import { APISuiteGet, APISuiteGetTenants } from '../ApplicationSuites/ApplicationSuites.api';

import { APITenantGetResponse, APITenantPostParams } from './TenantApiTypeDefs';
import {
    APITenantDelete,
    APITenantGet,
    APITenantPost,
    APITenantPut,
} from './Tenants.api';
import { FetchTenantDetailsParams, FetchTenantDetailsResponse } from './TenantThunkTypeDefs';

export const fetchTenants = createAsyncThunk('tenants/fetchTenants', async (item: { id: string, signal?: AbortSignal } ) => {
    const response = await APISuiteGetTenants(item);
    return response.data;
});

export const fetchTenantDetails = createAsyncThunk(
    'tenantDetails/fetchDetails',
    async (fetchParams: FetchTenantDetailsParams):
Promise<FetchTenantDetailsResponse> => {
        const requests = [
            APISuiteGet({ id: fetchParams.applicationSuiteId }),
            APITenantGet({ id: fetchParams.tenantId })
        ];
        const responses = await Promise.all(requests);
        const tenantDetailsResponse = responses[1] as APITenantGetResponse;

        // url app suite id does not match url tenant app suite id
        if (responses[0].data.id !== tenantDetailsResponse.data.applicationSuiteId) {
            throw new APIError(404);
        }
        return {
            applicationSuiteId: responses[0].data.id,
            applicationSuiteName: responses[0].data.name,
            id: tenantDetailsResponse.data.id,
            name: tenantDetailsResponse.data.name,
            tenantRequiresLicense: tenantDetailsResponse.data.isLicenseRequired
        };
    });

export const postTenant = createAsyncThunk('tenants/postTenant', async (item: APITenantPostParams) => {
    const response = await APITenantPost(item);
    return {
        item,
        response
    };
});

export const deleteTenant = createAsyncThunk('tenants/deleteTenant', async (item: {id: string, suiteId: string }) => {
    const response = await APITenantDelete({ id: item.id });
    const rows = await handleListFetch(APISuiteGetTenants({ id: item.suiteId }));
    return {
        id: item.id,
        response,
        rows
    };
});

export const putTenant = createAsyncThunk('tenants/putTenant', async (item: { suiteId:string, tenantId:string, name:string }) => {
    const response = await APITenantPut(item);
    const rows = await handleListFetch(APISuiteGetTenants({ id: item.suiteId }));
    return {
        item,
        response,
        rows
    };
});
